import doc                        from '@widesk-core/decorators/doc';
import model                      from '@widesk-core/decorators/model';
import NetworkServiceModel        from '@/models/NetworkServiceModel';
import RelationRequestStatusModel from './RelationRequestStatusModel';
import RelationRequestModel       from './RelationRequestModel';

@model.urnResource('relation_request_status_history')
@doc.path('/relation_request_status_histories/{?id}')
export default class RelationRequestStatusHistoryModel extends NetworkServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'contact': id;
		'contactStatus': id;
		'id': id;
		'updatedAt[after]': string;
		'updatedAt[before]': string;
		'updatedAt[strictly_after]': string;
		'updatedAt[strictly_before]': string;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(RelationRequestModel) declare relationRequest: RelationRequestModel;
	@doc.model(RelationRequestStatusModel) declare relationRequestStatus: RelationRequestStatusModel;
}